/**
 * Single source of truth for the user-facing product name.
 *
 * Every UI surface (page titles, login screen, top bar, settings, copy that
 * mentions the product) must render this constant instead of a string
 * literal, so a rebrand is a one-line change.
 *
 * Deliberately NOT covered by this constant — these are stable identifiers,
 * not branding, and renaming them breaks things:
 *   - npm package scope (@a8-planner/*)
 *   - localStorage keys (e.g. 'a8planner-ui' — renaming resets user prefs)
 *   - database / infra resource names
 *
 * One manual companion: apps/web/index.html <title> is the pre-JS fallback
 * and cannot import TypeScript — keep it in sync by hand (main.tsx overwrites
 * it with APP_NAME as soon as the bundle loads).
 */
export const APP_NAME = 'Algoritmia Group';
